export const hasMultilanguage = false;
export const defaultLanguage = "bg";
export const availableLanguages = [
  { name: "Български", flag: "🇧🇬", value: "bg" },
  { name: "English", flag: "🇬🇧", value: "en" },
];
